import Vue from "vue";
import App from "./App.vue";
import router from './router';
import store from './store';

import VueAnalytics from 'vue-analytics';

/* configurações e registros importantes ficaram direto no fonte do argon */
import Argon from "./plugins/argon-kit";

import './registerServiceWorker';

import VueWait from 'vue-wait';

Vue.config.productionTip = false;
Vue.use(Argon);

Vue.use(VueAnalytics, {
  id: 'UA-144702785-1',
  router,
  ecommerce: {
    enabled: true
  }
});

export default new Vue({
  router,
  store,
  wait: new VueWait({
    useVuex: true
  }),
  render: h => h(App)
}).$mount("#app");
